import { useState,useEffect,useContext} from "react";
import axios from "axios";
import GetCurrentLocation from "../../location/getCurrentLocation";
import HomeBanner from "../../banner/homeBanner";
import PropertyType from "./propertyType";
import PropertyList from "./propetryList";
import HomeBuilder from "./homeBuilder";
import HomeAgent from "./homeAgent";
import Faq from "./faq";
import DistrictProperty from "./districtProperty";
import PostPropertyStrip from "./postPropertyStrip";
import { VscClose } from "react-icons/vsc";
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { RoleContext } from "../Userdatacontext/Datacontexts";

function HomePage() {
  const [district, setDistrict] = useState("");
  const [error, setError] = useState("");
  const { data, fetchpropertydetails,gettokenval } = useContext(RoleContext);

  useEffect(() => {
    if (district) {
      fetchpropertydetails()
    }
  }, [gettokenval]);

  return (
    <>
      {/* Fetch user location on page load */}
      <GetCurrentLocation setLocation={setDistrict} setError={setError} />

      {/* Announcement Bar */}
      <div className="announcementBar">
        <div className="container">
          <div className="announcementBarMain">
            <p>Welcome to Kerala Plots. Malayali's Real Estate Partner.</p>
          {/* <p>{district ? `Your district: ${district}` : error}</p>*/}
            <div className="closeAnnouncementBar">
              <VscClose />
            </div>
          </div>
        </div>
      </div>


      {/* Other Components */}
      <HomeBanner />
      <PropertyType />
      <PropertyList />
      <HomeBuilder />
      <HomeAgent />
      <Faq />
      <DistrictProperty />
      <PostPropertyStrip />
    </>
  );
}

export default HomePage;
